module.exports = __webpack_public_path__ + "img/arrowLeftPromo.607b8296.svg";